import { arrayOf, shape, string } from "prop-types";

import Anchor from "web/Components/Common/Anchor";

import classify from "web/classify";

import defaultClasses from "./categories.scss";

const Categories = ({ classes, activeCategory, categories }) => {
  return (
    <nav className={classes.root}>
      <ul className={classes.list}>
        {categories?.map((category) => (
          <li className={classes.item} key={category.name}>
            <Anchor
              className={
                activeCategory === category.name
                  ? classes.link_active
                  : classes.link
              }
              to={category.link}
              title={category.name}
            >
              {category.name}
            </Anchor>
          </li>
        ))}
      </ul>
    </nav>
  );
};

Categories.propTypes = {
  activeCategory: string,
  categories: arrayOf(
    shape({
      link: string,
      name: string,
    }).isRequired
  ).isRequired,
  classes: shape({
    root: string,
    list: string,
    link: string,
    link_active: string,
    item: string,
  }).isRequired,
};

Categories.defaultProps = {
  activeCategory: "",
};

export default classify(defaultClasses)(Categories);
